<div *ngIf="object" class="client_pageBody body" style="padding: 0">
  <div class="content item_details_page">
    <div class="tt_sidebar itemImages">
      <div class="mobile_hide">
        <img
          [src]="locationImage(object,object.images[imageIndex])"
          (click)="showImage(imageIndex)"
          class="tt_sidebar_image"
        />
        <div class="image_grid" *ngIf="object.images.length>1">
          <img
            *ngFor="let image of object.images; let i =index"
            [src]="locationImage(object,image)"
            [class.selected]="imageIndex==i"
            (click)="imageIndex= i"
            style="width: 100px; height: 100px; object-fit: cover"
          />
        </div>
      </div>
      <!-- <div *ngFor="let image of object.images" class="mobile_hide">
        <img [src]="locationImage(object,image)" class="tt_sidebar_image" />
      </div> -->

      <!--Mobile Carousel-->
      <div class="desktop_hide image_carousel">
        <fixed-carousel>
          <ng-container *ngFor="let image of object.images; let i=index">
            <ng-container *fixedCarouselItem>
              <img [src]="locationImage(object,image)" />
            </ng-container>
          </ng-container>
        </fixed-carousel>
      </div>
    </div>

    <!--Right Side-->
    <div class="tt_right">
      <div>
        {{ lang(object.organization?.name,object.organization?.name_lang) }}
      </div>
      <div class="font-bold text-2xl mb-1 break-words">
        {{ lang(object.name,object.name_lang) }}
      </div>
      <!--Description-->
      <div
        [innerHtml]="description"
        style="margin: 1rem 0"
        class="ckeditor-content"
      ></div>

      <div class="item_info">
        <div class="line_item" *ngIf="object.tel">
          <fa-icon icon="phone-flip" class="icon"></fa-icon>
          {{object.tel}}
        </div>
        <div class="line_item" *ngIf="object.email">
          <fa-icon icon="envelope" class="icon"></fa-icon>
          {{object.email}}
        </div>
        <div class="line_item">
          <fa-icon icon="map-location-dot" class="icon"></fa-icon>
          <div (click)="openGoogleMap()" class="text-link">
            {{ lang(object.address,object.address_lang) }}
          </div>
        </div>
        <div class="line_item">
          <fa-icon icon="clock" class="icon"></fa-icon>
          <div>
            <div *ngFor="let l of openingHours">
              <!-- {{ lang(l, l_lang) }} -->
              {{l}}
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class="body_section">
        <div class="text-xl md:text-2xl font-bold">
          {{_common.Space_rental}}
        </div>
        <ng-container *ngIf="activeSpaces.length<1">
          <div class="text-center md:text-left my-8 text-gray-400">
            {{_common.no_space}}
          </div>
        </ng-container>

        <div class="grid gap-2 grid-cols-1 sm:grid-cols-2">
          <ng-container *ngFor="let space of object.spaces">
            <app-space-card
              *ngIf="space.active"
              [space]="$any(space)"
            ></app-space-card>
          </ng-container>
        </div>
      </div>

      <ng-container *ngIf="object.facilities?.length">
        <hr />

        <div class="body_section mb-8">
          <div class="sectionHeader">
            <div class="title spacer">{{_common.OtherFacilities}}</div>
          </div>
          <div class="facilityList">
            <div *ngFor="let f of object.facilities" class="facility_item">
              <img
                *ngIf="f.images[0]"
                [src]="facilityImage(f,f.images[0])"
                style="width: 50px; height: 50px; object-fit: contain"
              />
              <div class="info w-full align-items flex flex-col">
                <div class="spacer">{{ lang(f.name,f.name_lang) }}</div>
                <!-- <div class="flex justify-end">
                  <div class="client_chip mt-2" [ngClass]="f.fee">
                    {{ _common.Facility[f.fee] }}
                    <span *ngIf="f.fee==fees.custom">$&nbsp;{{f.feeText}}</span>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="desktop_hide flex justify-center">
      <div
        [routerLink]="[session.path('/location-search')]"
        class="client_button"
      >
        {{ _common.viewAllCenters }}
      </div>
    </div>
    <div class="mb-6"></div>

    <!--<ng-container *ngIf="position">
      <div *ngIf="mapService.apiLoader | async">
        <google-map height="300px" width="100%" [center]="position" [zoom]="12">
          <map-marker [position]="position" [options]="options"></map-marker>
        </google-map>
      </div>
    </ng-container>-->
  </div>
</div>
